type InputProps = {
  label?: string
  name: string
  type?: string
  value?: string
  defaultValue?: string
  placeholder?: string
  className?: string
  labelClassName?: string
  labelError?: string
  autofocus?: boolean
  onChange?: (e: React.FormEvent<HTMLInputElement>) => void
}

export const Input = ({
  label,
  name,
  type,
  value,
  defaultValue,
  placeholder,
  className,
  labelClassName,
  labelError,
  autofocus,
  onChange,
}: InputProps) => {
  return (
    <div className="flex flex-col items-start justify-center gap-2 w-full">
      {label && (
        <div className="w-full flex items-center justify-between">
          <label
            className={`text-zinc-200 text-left text-sm ${
              labelClassName ? labelClassName : ""
            }`}
            htmlFor={name}
          >
            {label}
          </label>
          {labelError && <p className="text-red-500 text-sm">{labelError}</p>}
        </div>
      )}
      <input
        type={type || "text"}
        name={name}
        autoFocus={autofocus || false}
        autoComplete="off"
        autoCorrect="off"
        defaultValue={defaultValue}
        placeholder={placeholder}
        onChange={onChange}
        className={`p-4 w-full text-white bg-zinc-800 text-lg outline-none border-2 border-zinc-700 focus:border-zinc-400 transition rounded-xl shadow-md ${
          className ? className : ""
        }`}
      />
    </div>
  )
}
